export const environment = {
    alias: 'referentka-prod',
    firebaseProject: 'memowl',
    sentryDsn:
        'https://b4ad1ed4387e95185eb84e148de0f8b0@o4508794559070208.ingest.de.sentry.io/4508794606256208',
};
